import { ApiQueries, DaymapIcon, DaymapIconType, useStudent, TableComponent, AttendanceMap } from "daymap-react";
import { useParams } from "react-router-dom";
import { PageContainer, PageDescriptor } from "../../../components/layout";
import { Stack, Tab, Tabs } from "@mui/material";
import { useState } from "react";

function Attendance() {
    const { studentId } = useParams();
    const student = useStudent(Number(studentId));   
    const [ reportIndex, setReportIndex] = useState(0); 

    return (
        <PageContainer>
            <PageDescriptor title="Attendance" icon={<DaymapIcon iconType={DaymapIconType.Attendance} />}>
                View {student?.Displayname}'s attendance counts and rates for {(new Date()).getFullYear()}
            </PageDescriptor>
            <Stack spacing={2}>
                <Tabs color="primary" value={reportIndex} onChange={(_, v) => setReportIndex(v)}>
                    <Tab label="Attendance Map" id="map" />
                    <Tab label="Attendance Rates" id="rates" />
                </Tabs>
                {reportIndex === 0 && <AttendanceMap studentId={Number(studentId)} />}
                {reportIndex === 1 && <Rates studentId={Number(studentId)} />}
            </Stack>
        </PageContainer>
    );
}

export function Rates({studentId}:{studentId:number}) {
    const { isPending, data } = new ApiQueries.student.getAttendanceRates({ studentId: studentId }).ToQuery();
    const columns = ["Class", "Class Code", "Teacher", "Approved %", "Unapproved %", "Approved", "Unapproved", "Lessons", "Cancelled"];
    
    const rows = Array.isArray(data) ? data.map((row) => {
        return {
            class: row.ClassName,
            classCode: row.ClassCode,
            teacherName: row.TeacherName,
            approvedPercentage: row.ApprovedPercent,
            unapprovedPercentage: row.UnapprovedPercent,
            approved: row.ApprovedAbsentCount,
            unapproved: row.UnapprovedAbsentCount,
            lessons: row.TotalCount,
            cancelled: row.CancelledCount,
        }
    }) : [];

    return <TableComponent columns={columns} rows={rows} isPending={isPending} numSticky={1} />
}

export default Attendance;